import {
    Component,
    ElementRef,
    Input,
    OnInit,
    Renderer2,
    ViewChild,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BaseComponent } from 'src/app/core/abstractions/base.component';
import { InactiveUserService } from 'src/app/core/components/inactive-user/inactive-user.service';
import { AuthFirebaseService } from 'src/app/core/services/auth-firebase.service';
import { UserService } from 'src/app/core/services/user.service';
import { environment } from 'src/environments/environment';

@UntilDestroy()
@Component({
    selector: 'app-header-menu',
    templateUrl: './header-menu.component.html',
    styleUrls: ['./header-menu.component.scss'],
})
export class HeaderMenuComponent extends BaseComponent implements OnInit {
    @ViewChild('menu', { static: false })
    menu: ElementRef;
    isMobile = false;
    websitePublicURL = environment.websiteBaseURL;
    copPublicURL = environment.copBaseURL;

    expand = false;

    @Input()
    interestForm = false;

    constructor(
        private userService: UserService,
        private auth: AuthFirebaseService,
        private inactiveUserTracker: InactiveUserService,
        private renderer: Renderer2
    ) {
        super();
    }

    ngOnInit(): void {
        this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    }

    toggleMenu() {
        if (this.expand) {
            this.close();
        } else {
            this.open();
        }
    }

    goToTopAndToggleMenu() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.toggleMenu();
    }

    get activeRoute(): string {
        return this.router.url.split('?')[0];
    }

    open() {
        this.expand = true;
        this.renderer.setStyle(this.menu.nativeElement, 'width', '100%');
    }

    close() {
        this.menu.nativeElement.classList.add('swing-out-top-fwd');
        this.menu.nativeElement.classList.remove('swing-in-top-fwd');
        this.menu.nativeElement.classList.remove('responsive');
        this.renderer.setStyle(this.menu.nativeElement, 'width', '50px');
        this.renderer.setStyle(this.menu.nativeElement, 'float', 'right');

        setTimeout(() => {
            this.menu.nativeElement.classList.remove('swing-out-top-fwd');
            this.expand = false;
        }, 500);
    }

    getPortalRoute(): string {
        return environment.portalBaseURL;
    }

    logout() {
        this.spinner.show();
        this.inactiveUserTracker.stopInactiveUserSchedule();
        this.close();

        this.auth
            .signOut()
            .pipe(untilDestroyed(this))
            .subscribe(
                () => {
                    this.spinner.hide();
                    this.navigate([this.getLogoutURL()]);
                },
                () => {
                    this.spinner.hide();
                }
            );
    }

    getLogoutURL() {
        return '/auth';
    }

    getUserIsLogged(): boolean {
        return (
            !!this.userService.getLoggedInUser() &&
            !!this.userService.getLoggedInUser().id
        );
    }

    isUserLoggedInFaq(): boolean {
        return this.getUserIsLogged() && this.activeRoute === '/';
    }
}
